import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import loginServices from "../services/loginServices";

const initialState: any = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
  admin: {},
};

export const loginAdmin = createAsyncThunk<any, any>(
  "admin/login",
  async (body, thunkAPI) => {
    try {
      const res = await loginServices.login(body);
      return res;
    } catch (error: any) {
      const message =
        (error.response &&
          error.response?.data &&
          error.response?.data?.message[0]) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminAuthReducer = createSlice({
  name: "admin",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      state.admin = {};
    },
    resetMessage: (state) => {
      state.message = "";
    },
    updateAdminUser: (state, action) => {
      const newAdminData = action.payload?.data?.admin_user
      state.admin = {
        ...state.admin,
        name: newAdminData?.name,
        nickname: newAdminData?.nickname,
        email: newAdminData?.email,
        image: newAdminData?.image,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.admin = {
          ...action.payload?.data?.admin_user,
          authorization: action?.payload?.headers["authorization"]
        };
        state.message = "";
      })
      .addCase(loginAdmin.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.admin = {};
      });
  },
});

export const { reset, resetMessage, updateAdminUser } = adminAuthReducer.actions;

export default adminAuthReducer.reducer;
